import styled from 'styled-components'

import { theme } from 'styles/theme'

interface UserAvatarProps {
  id?: number
  name: string
}

const AVATAR_COLORS = [
  theme.colors.AvatarColorLightRed,
  theme.colors.AvatarColorPink,
  theme.colors.AvatarColorLightPurple,
  theme.colors.AvatarColorPurple,
  theme.colors.AvatarColorDarkPurple,
  theme.colors.AvatarColorBlue,
  theme.colors.AvatarColorLightBlue,
  theme.colors.AvatarColorTurquoise,
  theme.colors.AvatarColorDarkTurquoise,
  theme.colors.AvatarColorDarkGreen,
  theme.colors.AvatarColorGreen,
  theme.colors.AvatarColorLightGreen,
  theme.colors.AvatarColorYellow,
  theme.colors.AvatarColorDarkYellow,
  theme.colors.AvatarColorOrange,
  theme.colors.AvatarColorDarkOrange,
  theme.colors.AvatarColorBrown,
  theme.colors.AvatarColorGray
]

interface WithColor {
  color: string
}

const UserAvatarContainer = styled.label<WithColor>`
  background-color: ${({ color }) => color};
  font-weight: ${theme.fontWeights.bold};
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center; 
  inline-size: 2.6em;
  block-size: 2.6em;
`

export const UserAvatar = ({ id, name }: UserAvatarProps) => {
  const initials =
    id === undefined
      ? ''
      : name
          .replace(/[^a-zA-Z ]/g, '') // remove non alphanumeric characters and spaces
          .split(' ')
          .map((part) => part[0])
          .slice(0, 2)
          .join('')
          .toLocaleUpperCase()
  const color = AVATAR_COLORS[(id ?? 0) * 17 % AVATAR_COLORS.length] ?? 'red' // we multiply by 17 so the order of the colors will not be as in the order in the color plate and will look more random
  return <UserAvatarContainer {...{ color }}>{initials}</UserAvatarContainer>
}

export const EmptyUserAvatar = ({ title }: WithTitle) => (
  <UserAvatarContainer {...{ color: theme.colors.SecondaryLightGrey, title }} />
)
